import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BRAND } from '@platform/shared';
import { App } from './App';
import './index.css';
// Registers the install-prompt listener before the browser fires it.
import './lib/install';
import { captureReferral } from './lib/referral';

document.title = BRAND.name;
// Before any redirect drops the query string.
captureReferral();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
